<template>
  <v-app id="loader">
    <router-view>
    </router-view>
  </v-app>
</template>
<script>
export default {
  mounted () {
    console.log('Something')
  }
}
</script>
<style lang="scss" scoped>
  #loader {
    background: var(--v-primary-base);
  }
</style>
